import {
  INIT, SUCCESS, LOADING, ERROR,
} from '../../../utils/constants';
import {
  GET_VMS_AZURE, GET_VMS_AZURE_SUCCESS, GET_VMS_AZURE_ERROR
} from './constant';


const initialState = {
  phase: INIT,
  azureVmsList: null,
  error: null,
};

/**
 * User Reducer
 * @param {Object} state
 * @param {Object} action
 */
 

export function AzureVmsStore(state = initialState, action) {
  switch (action.type) {
    case GET_VMS_AZURE:
      return {
        ...state,
        phase: LOADING,
      };
    case GET_VMS_AZURE_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        azureVmsList: action.data,
        error: null,
      };
    case GET_VMS_AZURE_ERROR:
      return { ...state, phase: ERROR, error: action.error };





    default:
      return state;
  }
}
